var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.debug)?_c('div',{staticClass:"debug-feature"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }